import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Autocomplete } from "@totalsoft/rocket-webapp-components-deprecated";
import { GET_ASSET_CONDITION_TYPES_QUERY } from "../queries";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { assetConditionType } from "constants/queryTypes";
import { emptyArray, emptyString } from "constants/defaultValues";

function AssetConditionContent({ dialogState, setDialogState }) {
  const { t } = useTranslation();

  const yearList = useMemo(() => {
    let list = [];
    const currentYear = new Date().getFullYear();

    for (let i = currentYear + 1; i >= currentYear - 10; i--) {
      list.push({ id: i, manufacturingYear: i, manufacturingYearString: i.toString() });
    }

    return list;
  }, []);

  const { data: assetConditionTypes } = useQueryWithErrorHandling(GET_ASSET_CONDITION_TYPES_QUERY, {
    variables: {
      type: assetConditionType,
    },
  });

  const handleConditionChange = useCallback(
    (value) => {
      setDialogState((prev) => ({
        ...prev,
        conditionTypeId: value,
        conditionTypeName: assetConditionTypes?.assetConditionTypes.find((x) => x.id === value)?.name,
      }));
    },
    [setDialogState, assetConditionTypes]
  );

  const handleManufacturingChange = useCallback(
    (value) => {
      setDialogState((prev) => ({
        ...prev,
        manufacturingYear: value,
      }));
    },
    [setDialogState]
  );

  return (
    <Grid container direction="row" spacing={2}>
      <Grid item xs={6}>
        <Autocomplete
          key={"asset_condition"}
          label={t("Asset.Condition")}
          simpleValue
          value={dialogState.conditionTypeId || emptyString}
          options={assetConditionTypes?.assetConditionTypes || emptyArray}
          onChange={handleConditionChange}
          noOptionsText={t("General.AutocompleteNoOptions")}
        />
      </Grid>
      <Grid item xs={6}>
        <Autocomplete
          key={"asset_manufacturingYear"}
          label={t("Asset.ManufacturingYear")}
          value={dialogState.manufacturingYear || emptyString}
          simpleValue
          labelKey="manufacturingYearString"
          valueKey="manufacturingYear"
          options={yearList || emptyArray}
          onChange={handleManufacturingChange}
          noOptionsText={t("General.AutocompleteNoOptions")}
        />
      </Grid>
    </Grid>
  );
}

AssetConditionContent.propTypes = {
  dialogState: PropTypes.object.isRequired,
  setDialogState: PropTypes.func.isRequired,
};

export default AssetConditionContent;
